class Neo3DViewer {
  constructor() {
    this.card     = document.getElementById('neo3dCard');
    this.shine    = document.getElementById('neo3dShine');
    this.spotlight = document.getElementById('neo3dSpotlight');

    if (!this.card) return;

    this.rotX = -8;
    this.rotY = 20;
    this.velX = 0;
    this.velY = 0.4;
    this.dragging = false;
    this.lastX = 0;
    this.lastY = 0;
    this.autoRotate = true;
    this.resumeTimer = null;

    this.bind();
    this.tick();
  }

  bind() {
    const c = this.card;

    c.addEventListener('mousedown',  e => this.startDrag(e.clientX, e.clientY));
    c.addEventListener('touchstart', e => this.startDrag(e.touches[0].clientX, e.touches[0].clientY), { passive: true });

    document.addEventListener('mousemove',  e => this.onMove(e.clientX, e.clientY));
    document.addEventListener('touchmove',  e => { if (!this.dragging) return; e.preventDefault(); this.onMove(e.touches[0].clientX, e.touches[0].clientY); }, { passive: false });

    document.addEventListener('mouseup',  () => this.stopDrag());
    document.addEventListener('touchend', () => this.stopDrag());
  }

  startDrag(x, y) {
    this.dragging   = true;
    this.autoRotate = false;
    this.lastX = x;
    this.lastY = y;
    this.card.style.cursor = 'grabbing';
    clearTimeout(this.resumeTimer);
  }

  onMove(x, y) {
    if (!this.dragging) return;
    const dx = x - this.lastX;
    const dy = y - this.lastY;
    this.velX = dx * 0.6;
    this.velY = dy * 0.35;
    this.rotY += this.velX;
    this.rotX -= this.velY;
    this.rotX  = Math.max(-30, Math.min(30, this.rotX));
    this.lastX = x;
    this.lastY = y;
    this.apply();
  }

  stopDrag() {
    if (!this.dragging) return;
    this.dragging = false;
    this.card.style.cursor = 'grab';
    /* momentum: keep velocity decaying, then resume auto-spin */
    this.resumeTimer = setTimeout(() => { this.autoRotate = true; this.velX = 0.4; }, 1800);
  }

  apply() {
    this.card.style.transform =
      `perspective(900px) rotateX(${this.rotX}deg) rotateY(${this.rotY}deg)`;

    /* Shine: light comes from upper-left, shifts with rotation */
    const nx = ((this.rotY % 360) / 180);   /* -1 → 1 */
    const ny = this.rotX / 30;
    const lx = 40 - nx * 35;
    const ly = 30 + ny * 20;
    if (this.shine) {
      this.shine.style.background =
        `radial-gradient(ellipse 60% 60% at ${lx}% ${ly}%, rgba(255,245,200,0.22) 0%, transparent 70%)`;
    }

    /* Floor spotlight tracks Y rotation */
    const spread = Math.abs(Math.sin((this.rotY * Math.PI) / 180));
    if (this.spotlight) {
      this.spotlight.style.background =
        `radial-gradient(ellipse ${55 + spread * 20}% 35% at 50% 50%, rgba(201,168,76,${0.18 + spread * 0.12}) 0%, transparent 75%)`;
    }
  }

  tick() {
    if (this.autoRotate && !this.dragging) {
      this.rotY += 0.4;
      this.apply();
    } else if (!this.dragging && (Math.abs(this.velX) > 0.01)) {
      this.velX *= 0.96;
      this.rotY += this.velX;
      this.apply();
    }
    requestAnimationFrame(() => this.tick());
  }
}

document.addEventListener('DOMContentLoaded', () => new Neo3DViewer());
